<template>
  <div>
    <conversions-table v-if="haveConversions"/>

    <div v-else class="conversions-card conversions-table-empty-state">
      <div class="empty-state-img">
        <img src="/img/empty_page.2ea2b496.svg" alt="">
      </div>

      <div class="empty-state-desc">
        <p> {{$t('tracking.conversions_tab.empty_state_desc_p1')}} <br>
          {{$t('tracking.conversions_tab.empty_state_desc_p2')}} </p>
      </div>

      <div class="empty-state-action">
        <router-link @click="$gtag.event('Create_Conversion')" :to="{ name: 'conversions-create'}">
          <button>{{$t('tracking.conversions_tab.btn_create')}}</button>
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
import ConversionsTable from './ConversionsTable.vue'

export default {
  props: ['haveConversions'],

  components: {
    ConversionsTable
  }
}
</script>

<style lang="scss" scoped>
.conversions-table-empty-state {
  margin-top: 32px;

  .empty-state-title {
    h4 {
      color: #2c2c2c;
      font-weight: 500;
      font-size: 24px;
    }
  }

  .empty-state-img {
    text-align: center;
    margin-top: 80px;

    img {
      width: 378px;
    }
  }

  .empty-state-desc {
    text-align: center;

    p {
      color: rgba(0, 0, 0, 0.56);
      font-size: 18px;
      margin-bottom: 40px;
    }
  }

  .empty-state-action {
    text-align: center;

    button {
      background: #0092d7;
      border-radius: 4px;
      padding: 11px 41px;
      color: #fff;
      cursor: pointer;
      font-weight: 500;
      font-size: 16px;
      border: none;
      outline: none;
      box-shadow: none;
    }
  }
}

@media (max-width: 768px) {
  .search-connection,
  .empty-state-action {
    width: 288px !important;
  }
}
</style>
